import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";


const useStles = makeStyles(() => ({
    modal: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: '100%',
        outline: 'none',
        border: 'none',
        zIndex: '10001 !important',

    },
    grid: {
        width: '40%',
        minHeight: 200,
        backgroundColor: 'white',
        borderRadius: 8,
        padding: 20,
        minWidth: 300
    },
    gridBtn: {
        display: "flex",
        justifyContent: "flex-end",
        width: '100%',
    }
}));



export default React.memo(function Index({ data, open, setOpen, sejamInfoState, hendelRestart }) {

    const classes = useStles();


    const handleClickButton = () => {
        setOpen((prev) => !prev);
    };

    return (
        <>
            {open && (
                <>
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className={classes.modal}
                        open={open}
                        onClose={() => handleClickButton()}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >
                        <Fade in={open}>
                            <div className={classes['modal']}>
                                <div className={classes['grid']}>
                                    <h3 style={{ color: '#DA212E', marginBottom: 15 }}>
                                        عدم قبولی در آزمون
                                    </h3>
                                    <div>
                                        <p>
                                            کاربر گرامی
                                            <span>
                                                {/* {`

             ${sejamInfoState?.body?.privatePerson?.firstName}
             ${sejamInfoState?.body?.privatePerson?.lastName}،
             `} */}
                                            </span>
                                        </p>
                                        <p>
                                            {`
                                            شما حداقل نمره قبولی در آزمون (%${data?.max_score}) را کسب ننموده اید لطفا جهت قبولی در آزمون پاسخ سوالات خود را اصلاح نمایید
                                            `}
                                        </p>
                                        {/* <p>
                                            <span>
                                                {` ${"سوال :"} `}

                                            </span>
                                            {
                                                data?.data?.map((item, index) => {
                                                    return (
                                                        <span>
                                                            {`${item}`}
                                                            {index + 1 !== data?.data.length && (<>,</>)}
                                                        </span>
                                                    )
                                                })
                                            }
                                        </p> */}
                                    </div>
                                    <div className={classes['gridBtn']}>
                                        <Button
                                            className={"footer-button-back m-2"}
                                            onClick={() => hendelRestart()}
                                        >
                                            آزمون مجدد
                                        </Button>
                                        <Button
                                            className={"footer-button-next-active m-2"}
                                            onClick={() => setOpen(false)}
                                        >
                                            بستن
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Fade>
                    </Modal>

                </>
            )
            }

        </>
    );
}

)
